export var ACTIONS;
(function (ACTIONS) {
    ACTIONS["GOOGLE_LOGIN"] = "GOOGLE_LOGIN";
    ACTIONS["APPLE_LOGIN"] = "APPLE_LOGIN";
    ACTIONS["OTHER_EMAIL"] = "OTHER_EMAIL";
    ACTIONS["CLOSE_MODAL"] = "CLOSE_MODAL";
    ACTIONS["NEED_HELP"] = "NEED_HELP";
    ACTIONS["GO_HOME"] = "GO_HOME";
})(ACTIONS || (ACTIONS = {}));
